import * as React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Link as MuiLink } from '@ally/metronome-ui'

const StyledMuiLink = styled(MuiLink)`
  flex-shrink: 0;
`

const OpenAccountButton: React.FC = () => {
  return (
    <StyledMuiLink
      variant="primary"
      text="Open an Account"
      size="sm"
      allytmln="open an account"
    >
      <Link to="/products-and-rates" />
    </StyledMuiLink>
  )
}

export default OpenAccountButton
